import router from "../../router";

const DEFAULT_THUMB = "https://storage.googleapis.com/ewvapp/assets/defaultThumb.png";
const state = {
  videos: [],
  selectedVideo: null
};

const mutations = {
  ADD_VIDEO(state, video) {
    state.videos.push(video);
  },

  // For local display
  // Stats is for syncin
  ADD_VIEW_TO_VIDEO(state, videoId) {
    state.videos.find(video => video.id === videoId).views += 1;
  },
  ADD_LIKE_TO_VIDEO(state, videoId) {
    state.videos.find(video => video.id === videoId).likes += 1;
  },
  ADD_DISLIKE_TO_VIDEO(state, videoId) {
    state.videos.find(video => video.id === videoId).dislikes += 1;
  },
  SET_SELECTED_VIDEO(state, videoId) {
    state.selectedVideo = videoId;
  }
};

const actions = {
  downloadVideo({ commit, rootState }, video) {
    return new Promise(resolve => {
      this.state.Database.db
        .collection("videos")
        .doc(video)
        .get()
        .then(doc => {
          if (doc.data().enabled) {
            const videoTemp = {
              ...doc.data(),
              id: doc.id
            };
            if (videoTemp.externalAudio) {
              rootState.Database.storage.refFromURL(videoTemp.externalAudioUrl).getDownloadURL().then(url => {
                videoTemp.externalAudioUrl = url;
              });
            }
            try {
              rootState.Database.storage.refFromURL(videoTemp.image).getDownloadURL().then(url => {
                videoTemp.imageUrl = url;
              }).catch(() => {
                videoTemp.imageUrl = DEFAULT_THUMB;
              });
            } catch (error) {
              videoTemp.imageUrl = DEFAULT_THUMB;
            }
            commit("ADD_VIDEO", videoTemp);
          }
          resolve(doc.data().enabled);
        });
    });
  },
  addViewToVideo({ commit }, videoId) {
    commit("ADD_VIEW_TO_VIDEO", videoId);
    commit("ADD_VIEW_TO_STATS", videoId);
  },
  addLikeToVideo({ commit }, videoId) {
    commit("ADD_LIKE_TO_VIDEO", videoId);
    commit("ADD_LIKE_TO_STATS", videoId);
  },
  addDislikeToVideo({ commit }, videoId) {
    commit("ADD_DISLIKE_TO_VIDEO", videoId);
    commit("ADD_DISLIKE_TO_STATS", videoId);
  },
  playVideo({ commit, rootGetters, dispatch }, video) {
    
    if (video.type !== undefined && video.type === "live") {
      commit("SET_SELECTED_VIDEO", video);
      dispatch("initializeScheduledLiveclass", { studioId: video.studioId, classId: video.classId });
    } else {
      const id = video.classId ? video.classId : video.id;
      const videoObject = rootGetters.getVideos.find(vid => vid.id === id);
      if (videoObject !== undefined) {
        commit("SET_SELECTED_VIDEO", videoObject);
        commit("ADD_VIEW_TO_VIDEO", videoObject.id);
        commit("ADD_VIEW_TO_STATS", videoObject.id);
      }
    }

    if (router.currentRoute.path.substr(1) !== "Player") {
      router.push("Player");
    } else {
      // Hacky way to play a video if a video is already playing
      router.push("Home");
      setTimeout(() => { 
        router.push("Player"); 
      }, 500);
    }
  },
  stopVideo({ commit, state, dispatch }) {
    if (state.selectedVideo !== null && state.selectedVideo.type === "live") {
      dispatch("unsubscribeScheduledLiveclassListener");
    }
    commit("SET_SELECTED_VIDEO", null);
    router.push("Home");
  }
};

const getters = {
  getCurrentVideo(state) {
    return state.selectedVideo;
  },
  getTotalViews(state) {
    let t = 0;
    if (state.videos) {
      state.videos.forEach(video => {
        t += video.views;
      });
    }

    return t;
  },
  getVideos(state) {
    return state.videos;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Videos.js